<template>
  <form
    @submit.prevent="handleUpdatePassword()"
    data-cy="password-reset-form"
    ref="passwordForm"
  >
    <h3>Update Password</h3>
    <ion-list lines="full">
      <input-box
        :validator="$v.oldPassword"
        :error-messages="{ required: 'Please enter your old password.' }"
        :required="true"
        type="password"
        data-cy="old-password"
        v-model="oldPassword"
      >
        Old Password
      </input-box>
      <ion-item v-if="invalidOldPassword" color="danger">
        The old password is invalid.
      </ion-item>
      <input-box
        :validator="$v.newPassword"
        :error-messages="{
          required: 'Please choose a new password.',
          minLength: 'Your password must be at least 8 characters.'
        }"
        :required="true"
        type="password"
        data-cy="new-password"
        v-model="newPassword"
      >
        Choose New Password
      </input-box>
    </ion-list>
    <div class="ion-padding">
      <submit-button :submitting="submitting" data-cy="reset-password-submit">
        Save New Password
      </submit-button>
    </div>
  </form>
</template>

<script>
import { required } from "vuelidate/lib/validators";
import passwordValidation from "@/validators/PasswordValidation";
import { mapActions, mapGetters } from "vuex";
import ErrorAlert from "@/ErrorAlert";
import submittable from "@/mixins/submittable";

export default {
  mixins: [submittable],

  data: function() {
    return {
      oldPassword: "",
      newPassword: "",
      invalidOldPassword: false
    };
  },

  methods: {
    ...mapActions("auth", ["updatePassword"]),

    async handleUpdatePassword() {
      this.invalidOldPassword = false;
      this.$v.$touch();

      if (!this.$v.$invalid) {
        let updateResult = await this.updatePassword({
          oldPassword: this.oldPassword,
          newPassword: this.newPassword
        });

        if (updateResult === false) {
          if (this.authError.code === "auth/wrong-password") {
            this.invalidOldPassword = true;
          } else {
            ErrorAlert(this.authError.message);
          }
        } else {
          this.$v.$reset();
          this.oldPassword = "";
          this.newPassword = "";
          this.$refs.passwordForm.reset();
          this.successToast("Your password has been updated successfully.");
        }
      }
    }
  },

  computed: {
    ...mapGetters("auth", ["authError"])
  },

  validations: {
    oldPassword: {
      required
    },

    newPassword: passwordValidation
  }
};
</script>
